export default "__VITE_ASSET__L3VgTBYf__"